import { DateTime } from 'luxon';
import { Box, Divider, styled } from '@mui/material';
import { useFormArray } from 'shared/hooks/use-form-array';
import { Timeslot } from './time-slot';
import { TimeSlotFormContext } from './time-slot.types';

export const TimeSlotWrapper = () => {
  const timeslots = useFormArray<TimeSlotFormContext>('availability', {
    utcStartDateTime: DateTime.now().toUTC().toFormat(`T`),
    utcEndDateTime: DateTime.now().toUTC().toFormat(`T`),
  });

  return (
    <StyledContainer>
      {timeslots.fields.map((timeslot, index) => (
        <>
          <Timeslot key={timeslot.id} index={index} handleDelete={timeslots.deleteElement} />
          {index < timeslots.fields.length - 1 && <StyledDivider />}
        </>
      ))}
    </StyledContainer>
  );
};

const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
